import React from "react";
import { breakpoints, useMediaQuery } from "@tvg/design-system";
import { Header } from "@tvg/design-system/web";
import { HeaderContainer, Section } from "./styled-components";
import InfoText from "../InfoText";
import InfoContent from "../InfoContent";

export interface PromosInfoContentProps {
  content: {
    bloks: Array<{
      header: string;
      steps: Array<{
        stepNumber: string;
        stepDescription: string;
      }>;
      moreInfo?: string;
    }>;
  };
}

const PromosInfoContent = ({ content }: PromosInfoContentProps) => {
  const isMobile = useMediaQuery(breakpoints.tablet.max.sm);
  const validBloks = content.bloks?.filter(
    (blok) => blok.header?.trim() && blok.steps?.length
  );

  if (!validBloks?.length) return null;

  return (
    <Section>
      {content.bloks.map((blok) => (
        <div key={blok.header}>
          <HeaderContainer isMobile={isMobile}>
            <Header
              tag="h3"
              fontFamily="bold"
              color="--fd-colors-content-strong"
            >
              {blok.header}
            </Header>
          </HeaderContainer>
          {blok.moreInfo?.trim() ? (
            <InfoText content={blok.moreInfo} isMobile={isMobile} />
          ) : (
            blok.steps.map((step, index) => (
              <InfoContent
                key={step.stepNumber}
                stepNumber={step.stepNumber}
                description={step.stepDescription}
                isFirstStep={index === 0}
                isLastStep={index === blok.steps.length - 1}
                qaLabel={`${step.stepNumber}-StepCard`}
                isMobile={isMobile}
              />
            ))
          )}
        </div>
      ))}
    </Section>
  );
};

export default PromosInfoContent;
